import { DoubleSide, ShaderMaterial } from "three";

// Removed unused imports: useThree, useEffect, useState, MeshStandardMaterial, Texture

const vertexShader = `
    varying vec3 vNormal;
    void main() {
        vNormal = normalize(normalMatrix * normal); // Transform normal to view space and pass to fragment shader
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

const fragmentShader = `
    varying vec3 vNormal;
    void main() {
        // Visualize normals: map normal components (-1 to 1) to RGB colors (0 to 1)
        vec3 color = vNormal * 0.5 + 0.5;
        gl_FragColor = vec4(color, 1.0);
    }
`;

export const NormalsMaterial = () => {
  // Removed state and effect logic related to env maps

  return (
    <shaderMaterial
      vertexShader={vertexShader}
      fragmentShader={fragmentShader}
      side={DoubleSide}
      // No uniforms needed for this basic normal visualization
    />
  );
};

export const getNormalsMaterial = () => {
  return new ShaderMaterial({
    vertexShader: vertexShader,
    fragmentShader: fragmentShader,
    side: DoubleSide,
  });
};
